<div class="user-managment-page-container">
    <form
    name="form"
    (ngSubmit)="f.form.valid && processForm()"
    #f="ngForm"
    novalidate
    >
        <div class="row">
            <div class="col-md-6">
                <div class="form-group padding-right-10">
                    <mat-form-field>
                        <input
                            type="text"
                            placeholder="Name of the role"
                            matInput
                            [(ngModel)]="roleObj.role"
                            name="rolename"
                            #rolename="ngModel"
                            (keypress)="keyPressAlpha($event)"
                            required
                        >
                        <mat-error *ngIf="f.submitted && rolename.invalid">Role name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 margin-bottom-20 font-16">Has Access to <span class="no-data">(select at-least one)</span></div>
            <div class="col-md-8 row">
                <ng-template ngFor let-access [ngForOf]="accessList">
                    <div class="form-group feature-list font-16 col-md-6 margin-0">
                        <mat-checkbox  *ngIf="!dependentFeatures[access?.featureName]"
                            [checked]="featureSelection.isSelected(access)"
                            (change)="$event ? featureSelection.toggle(access) : null">
                                <span>{{access?.featureName}}</span>
                        </mat-checkbox>
                    </div>
                </ng-template>
                <ng-template ngFor let-parentFeature [ngForOf]="parentFeatures">
                    <div class="form-group feature-list  font-16 col-md-12 margin-0">
                        <mat-checkbox 
                            [checked]="parentFeatureToggleMap[parentFeature]"
                            (change)="onParentFeatureChange($event, parentFeature)">
                                <span>{{parentFeature}}</span>
                        </mat-checkbox>
                    </div>
                    <div class="row feature-list  feature-list--sub" *ngIf="parentFeatureToggleMap[parentFeature]">
                        <ng-template ngFor let-access [ngForOf]="accessList">
                            <div *ngIf="childFeatures[parentFeature] && childFeatures[parentFeature][access?.featureName]" class="form-group feature-list font-16 col-md-6 margin-0">
                                <mat-checkbox 
                                    [checked]="featureSelection.isSelected(access)"
                                    (change)="$event ? featureSelection.toggle(access) : null">
                                        <span>{{access?.featureName}}</span>
                                </mat-checkbox>
                            </div>
                        </ng-template>
                    </div>
                </ng-template>
                <div class="form-group feature-list font-16 col-md-12 margin-0">
    
                    <mat-checkbox [(ngModel)]="isSelectAll" [checked]="featureSelection.selected?.length===accessList?.length" name="selectAll" #selectAll="ngModel"
                        (change)="onSelectAllChange($event)">
                        <span>Select all</span>
                    </mat-checkbox>
                </div>
            </div>
        </div>
        
        <div class="margin-top-20 text-center">
            <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid || featureSelection.selected?.length === 0">
                <span *ngIf="!roleObj?.roleId">Create Role</span>
                <span *ngIf="roleObj?.roleId">Update Role</span>
            </button>
        </div>
    </form>
</div>
<div class="roles-list-container">
    <app-roles-list (editChange)="onRoleEdit($event)" [roleList]="roleList"></app-roles-list>
</div>